import React from 'react';
import { useTheme } from '@/components/theme-provider';
import { cn } from '@/lib/utils';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showText?: boolean;
  textClassName?: string;
}

const sizeClasses = {
  sm: 'h-8 w-auto',
  md: 'h-12 w-auto',
  lg: 'h-16 w-auto',
  xl: 'h-20 w-auto',
};

const fallbackSizeClasses = {
  sm: 'h-8 w-8',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
  xl: 'h-20 w-20',
};

const textSizeClasses = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-2xl',
  xl: 'text-3xl',
};

export const Logo: React.FC<LogoProps> = ({ 
  size = 'md', 
  className,
  showText = false,
  textClassName 
}) => {
  const { theme } = useTheme();
  const [imageError, setImageError] = React.useState(false);

  const handleImageError = () => {
    setImageError(true);
  };

  if (imageError) {
    // Fallback para quando as imagens não existem
    return (
      <div className={cn('flex items-center gap-3', className)}>
        <div className={cn(
          'bg-primary/10 rounded-lg flex items-center justify-center border-2 border-primary/20',
          fallbackSizeClasses[size]
        )}>
          <span className={cn('font-bold text-primary', textSizeClasses[size])}>
            SDR
          </span>
        </div>
        {showText && (
          <span className={cn('font-bold text-foreground', textSizeClasses[size], textClassName)}>
            SDR System
          </span>
        )}
      </div>
    );
  }

  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img
        src={theme === 'dark' ? '/logo-dark.png' : '/logo-light.png'}
        alt="Logo da Empresa"
        className={cn('object-contain', sizeClasses[size])}
        onError={handleImageError}
      />
      {showText && (
        <span className={cn('font-bold text-foreground', textSizeClasses[size], textClassName)}>
          SDR System
        </span>
      )}
    </div>
  );
};

// Componente específico para o header/navbar
export const HeaderLogo: React.FC<{ className?: string }> = ({ className }) => (
  <Logo size="sm" showText className={className} />
);

// Componente específico para a página de login
export const LoginLogo: React.FC<{ className?: string }> = ({ className }) => (
  <Logo size="xl" className={className} />
);

export default Logo;
